import { trackPlanCalendarClick } from 'analytics/trackers/workout';

import { Calendar } from 'components';

import useGetFormattedWorkoutPlan from './hooks/useGetFormattedWorkoutPlan';
import { usePlanContent } from './hooks/usePlanContent';

import * as S from './styled';

export const WorkoutPlanModule = () => {
    const { selectedDate, setSelectedDate } = useGetFormattedWorkoutPlan();

    const handleDateChange = (date: Date) => {
        trackPlanCalendarClick();
        setSelectedDate(date);
    };

    const { content } = usePlanContent();

    return (
        <S.PlanContainer data-testid="workout-plan-module" data-locator="workout-plan-module">
            <Calendar selectedDate={selectedDate} onDateChange={handleDateChange} />
            {content}
        </S.PlanContainer>
    );
};
